// Fetch groups
export const FETCH_BACH_GROUPS_REQUEST = 'FETCH_BACH_GROUPS_REQUEST';
export const fetchBachGroupsRequest = () =>
  ({ type: FETCH_BACH_GROUPS_REQUEST });

export const FETCH_BACH_GROUPS_SUCCESS = 'FETCH_BACH_GROUPS_SUCCESS';
export const fetchBachGroupsSuccess = (groups, available) =>
  ({ type: FETCH_BACH_GROUPS_SUCCESS, payload: { groups, available } });

export const FETCH_BACH_GROUPS_FAILURE = 'FETCH_BACH_GROUPS_FAILURE';
export const fetchBachGroupsFailure = (error) =>
  ({ type: FETCH_BACH_GROUPS_FAILURE, payload: error });

// Fetch questionnaire (by group, or all if no group)
export const FETCH_QUESTIONNAIRE_REQUEST = 'FETCH_BACH_QUESTIONNAIRE_REQUEST';
export const fetchQuestionnaireRequest = (group) =>
  ({ type: FETCH_QUESTIONNAIRE_REQUEST, payload: { group } });

export const FETCH_QUESTIONNAIRE_SUCCESS = 'FETCH_BACH_QUESTIONNAIRE_SUCCESS';
export const fetchQuestionnaireSuccess = (questions) =>
  ({ type: FETCH_QUESTIONNAIRE_SUCCESS, payload: { questions } });

export const FETCH_QUESTIONNAIRE_FAILURE = 'FETCH_BACH_QUESTIONNAIRE_FAILURE';
export const fetchQuestionnaireFailure = (error) =>
  ({ type: FETCH_QUESTIONNAIRE_FAILURE, payload: error });

// Submit questionnaire
export const SUBMIT_QUESTIONNAIRE_REQUEST = 'SUBMIT_BACH_QUESTIONNAIRE_REQUEST';
export const submitQuestionnaireRequest = (group, answers) =>
  ({ type: SUBMIT_QUESTIONNAIRE_REQUEST, payload: { group, answers } });

export const SUBMIT_QUESTIONNAIRE_SUCCESS = 'SUBMIT_BACH_QUESTIONNAIRE_SUCCESS';
export const submitQuestionnaireSuccess = (reading) =>
  ({ type: SUBMIT_QUESTIONNAIRE_SUCCESS, payload: { reading } });

export const SUBMIT_QUESTIONNAIRE_FAILURE = 'SUBMIT_BACH_QUESTIONNAIRE_FAILURE';
export const submitQuestionnaireFailure = (error) =>
  ({ type: SUBMIT_QUESTIONNAIRE_FAILURE, payload: error });

// Set reading like
export const SET_BACH_READING_LIKE_REQUEST = 'SET_BACH_READING_LIKE_REQUEST';
export const setBachReadingLikeRequest = (reading_id, like) =>
  ({ type: SET_BACH_READING_LIKE_REQUEST, payload: { reading_id, like } });

export const SET_BACH_READING_LIKE_SUCCESS = 'SET_BACH_READING_LIKE_SUCCESS';
export const setBachReadingLikeSuccess = () =>
  ({ type: SET_BACH_READING_LIKE_SUCCESS });

export const SET_BACH_READING_LIKE_FAILURE = 'SET_BACH_READING_LIKE_FAILURE';
export const setBachReadingLikeFailure = (error) =>
  ({ type: SET_BACH_READING_LIKE_FAILURE, payload: error });

// Fetch all flowers (catalog)
export const FETCH_BACH_ALL_FLOWERS_REQUEST = 'FETCH_BACH_ALL_FLOWERS_REQUEST';
export const fetchBachAllFlowersRequest = () =>
  ({ type: FETCH_BACH_ALL_FLOWERS_REQUEST });

export const FETCH_BACH_ALL_FLOWERS_SUCCESS = 'FETCH_BACH_ALL_FLOWERS_SUCCESS';
export const fetchBachAllFlowersSuccess = (flowers) =>
  ({ type: FETCH_BACH_ALL_FLOWERS_SUCCESS, payload: { flowers } });

export const FETCH_BACH_ALL_FLOWERS_FAILURE = 'FETCH_BACH_ALL_FLOWERS_FAILURE';
export const fetchBachAllFlowersFailure = (error) =>
  ({ type: FETCH_BACH_ALL_FLOWERS_FAILURE, payload: error });

// Capture lead
export const CAPTURE_BACH_LEAD_REQUEST = 'CAPTURE_BACH_LEAD_REQUEST';
export const captureLeadRequest = (email, source, metadata) =>
  ({ type: CAPTURE_BACH_LEAD_REQUEST, payload: { email, source, metadata } });

export const CAPTURE_BACH_LEAD_SUCCESS = 'CAPTURE_BACH_LEAD_SUCCESS';
export const captureLeadSuccess = () =>
  ({ type: CAPTURE_BACH_LEAD_SUCCESS });

export const CAPTURE_BACH_LEAD_FAILURE = 'CAPTURE_BACH_LEAD_FAILURE';
export const captureLeadFailure = (error) =>
  ({ type: CAPTURE_BACH_LEAD_FAILURE, payload: error });

// Create checkout (Stripe)
export const CREATE_BACH_CHECKOUT_REQUEST = 'CREATE_BACH_CHECKOUT_REQUEST';
export const createBachCheckoutRequest = (email, readingId) =>
  ({ type: CREATE_BACH_CHECKOUT_REQUEST, payload: { email, reading_id: readingId } });

export const CREATE_BACH_CHECKOUT_SUCCESS = 'CREATE_BACH_CHECKOUT_SUCCESS';
export const createBachCheckoutSuccess = (checkoutUrl) =>
  ({ type: CREATE_BACH_CHECKOUT_SUCCESS, payload: { checkoutUrl } });

export const CREATE_BACH_CHECKOUT_FAILURE = 'CREATE_BACH_CHECKOUT_FAILURE';
export const createBachCheckoutFailure = (error) =>
  ({ type: CREATE_BACH_CHECKOUT_FAILURE, payload: error });

// Create PayPal order
export const CREATE_BACH_PAYPAL_ORDER_REQUEST = 'CREATE_BACH_PAYPAL_ORDER_REQUEST';
export const createBachPaypalOrderRequest = (email, readingId) =>
  ({ type: CREATE_BACH_PAYPAL_ORDER_REQUEST, payload: { email, reading_id: readingId } });

export const CREATE_BACH_PAYPAL_ORDER_SUCCESS = 'CREATE_BACH_PAYPAL_ORDER_SUCCESS';
export const createBachPaypalOrderSuccess = (approveUrl) =>
  ({ type: CREATE_BACH_PAYPAL_ORDER_SUCCESS, payload: { approveUrl } });

export const CREATE_BACH_PAYPAL_ORDER_FAILURE = 'CREATE_BACH_PAYPAL_ORDER_FAILURE';
export const createBachPaypalOrderFailure = (error) =>
  ({ type: CREATE_BACH_PAYPAL_ORDER_FAILURE, payload: error });

// Verify PayPal purchase
export const VERIFY_BACH_PAYPAL_PURCHASE_REQUEST = 'VERIFY_BACH_PAYPAL_PURCHASE_REQUEST';
export const verifyBachPaypalPurchaseRequest = (paypalOrderId) =>
  ({ type: VERIFY_BACH_PAYPAL_PURCHASE_REQUEST, payload: { paypal_order_id: paypalOrderId } });

export const VERIFY_BACH_PAYPAL_PURCHASE_SUCCESS = 'VERIFY_BACH_PAYPAL_PURCHASE_SUCCESS';
export const verifyBachPaypalPurchaseSuccess = (reading) =>
  ({ type: VERIFY_BACH_PAYPAL_PURCHASE_SUCCESS, payload: { reading } });

export const VERIFY_BACH_PAYPAL_PURCHASE_FAILURE = 'VERIFY_BACH_PAYPAL_PURCHASE_FAILURE';
export const verifyBachPaypalPurchaseFailure = (error) =>
  ({ type: VERIFY_BACH_PAYPAL_PURCHASE_FAILURE, payload: error });

// Verify purchase
export const VERIFY_BACH_PURCHASE_REQUEST = 'VERIFY_BACH_PURCHASE_REQUEST';
export const verifyBachPurchaseRequest = (sessionId) =>
  ({ type: VERIFY_BACH_PURCHASE_REQUEST, payload: { session_id: sessionId } });

export const VERIFY_BACH_PURCHASE_SUCCESS = 'VERIFY_BACH_PURCHASE_SUCCESS';
export const verifyBachPurchaseSuccess = (reading) =>
  ({ type: VERIFY_BACH_PURCHASE_SUCCESS, payload: { reading } });

export const VERIFY_BACH_PURCHASE_FAILURE = 'VERIFY_BACH_PURCHASE_FAILURE';
export const verifyBachPurchaseFailure = (error) =>
  ({ type: VERIFY_BACH_PURCHASE_FAILURE, payload: error });

// Check access by email (24h active purchase)
export const CHECK_BACH_ACCESS_REQUEST = 'CHECK_BACH_ACCESS_REQUEST';
export const checkBachAccessRequest = (email) =>
  ({ type: CHECK_BACH_ACCESS_REQUEST, payload: { email } });

export const CHECK_BACH_ACCESS_SUCCESS = 'CHECK_BACH_ACCESS_SUCCESS';
export const checkBachAccessSuccess = (hasAccess, expiresAt) =>
  ({ type: CHECK_BACH_ACCESS_SUCCESS, payload: { hasAccess, expiresAt } });

export const CHECK_BACH_ACCESS_FAILURE = 'CHECK_BACH_ACCESS_FAILURE';
export const checkBachAccessFailure = (error) =>
  ({ type: CHECK_BACH_ACCESS_FAILURE, payload: error });

// Reset state
export const RESET_BACH_FLOWERS = 'RESET_BACH_FLOWERS';
export const resetBachFlowers = () =>
  ({ type: RESET_BACH_FLOWERS });
